export default "__VITE_ASSET__CBkKj8Fw__"